export const actions = {
  FONTS_LOAD_REQUESTED: 'FONTS_LOAD_REQUESTED',
  FONTS_LOAD_SUCCEEDED: 'FONTS_LOAD_SUCCEEDED',
  FONTS_LOAD_FAILED: 'FONTS_LOAD_FAILED',

  FONTS_FILTERED_LOAD_REQUESTED: 'FONTS_FILTERED_LOAD_REQUESTED',
  FONTS_FILTERED_LOAD_SUCCEEDED: 'FONTS_FILTERED_LOAD_SUCCEEDED',
  FONTS_FILTERED_LOAD_FAILED: 'FONTS_FILTERED_LOAD_FAILED',

  FONTS_DELETED_REQUESTED: 'FONTS_DELETED_REQUESTED',
  FONTS_DELETED_SUCCEEDED: 'FONTS_DELETED_SUCCEEDED',
  FONTS_DELETED_FAILED: 'FONTS_DELETED_FAILED',

  FONTS_INSERTERED_REQUESTED: 'FONTS_INSERTERED_REQUESTED',
  FONTS_INSERTERED_SUCCEEDED: 'FONTS_INSERTERED_SUCCEEDED',
  FONTS_INSERTERED_FAILED: 'FONTS_INSERTERED_FAILED',

  FONTS_UPDATED_REQUESTED: 'FONTS_UPDATED_REQUESTED',
  FONTS_UPDATED_SUCCEEDED: 'FONTS_UPDATED_SUCCEEDED',
  FONTS_UPDATED_FAILED: 'FONTS_UPDATED_FAILED',

  FONT_BYID_LOAD_REQUESTED: 'FONT_BYID_LOAD_REQUESTED',
  FONT_BYID_LOAD_SUCCEEDED: 'FONT_BYID_LOAD_SUCCEEDED',
  FONT_BYID_LOAD_FAILED: 'FONT_BYID_LOAD_FAILED',

  FONT_BYID_LOAD_INSERT_REQUESTED: 'FONT_BYID_LOAD_INSERT_REQUESTED',
  FONT_BYID_LOAD_INSERT_SUCCEEDED: 'FONT_BYID_LOAD_INSERT_SUCCEEDED',
  FONT_BYID_LOAD_INSERT_FILED: 'FONT_BYID_LOAD_INSERT_FILED',

  FONTS_UPDATED_ORDER_REQUESTED: 'FONTS_UPDATED_ORDER_REQUESTED',
  FONTS_UPDATED_ORDER_SUCCEEDED: 'FONTS_UPDATED_ORDER_SUCCEEDED',
  FONTS_UPDATED_ORDER_FAILED: 'FONTS_UPDATED_ORDER_FAILED',

  FONTS_GENERATE_REQUESTED: 'FONTS_GENERATE_REQUESTED',
  FONTS_GENERATE_SUCCEEDED: 'FONTS_GENERATE_SUCCEEDED',
  FONTS_GENERATE_FAILED: 'FONTS_GENERATE_FAILED',

  RESET_FONT: 'RESET_FONT'
}

export const getFontByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.FONT_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.FONT_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const getFontsAction = (dispatch, filtroFont) => {
  dispatch({
    type: actions.FONTS_LOAD_REQUESTED,
    payload: filtroFont,
  })
}

export const getFontsFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.FONTS_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const deleteFontsAction = (dispatch, id) => {
  dispatch({
    type: actions.FONTS_DELETED_REQUESTED,
    payload: id,
  })
}

export const generarFuentesAction = (dispatch, filter) => {
  dispatch({
    type: actions.FONTS_GENERATE_REQUESTED,
    payload: filter,
  })
}

export const onSubmitInsertFuenteFormAction = (dispatch, formData) => {
  dispatch({
    type: actions.FONTS_INSERTERED_REQUESTED,
    payload: formData,
  })  
}

export const resetFont = (dispatch)  => {  
  dispatch({
    type: actions.RESET_FONT
  })
}

export const onSubmitUpdateFuenteFormAction = (dispatch, formData) => {
  dispatch({
    type: actions.FONTS_UPDATED_REQUESTED,
    payload: formData,
  })
  dispatch({
    type: actions.RESET_FONT
  })
}

export const onSubmitUpdateOrdenFuenteAction = (dispatch, data) => {
  dispatch({
    type: actions.FONTS_UPDATED_ORDER_REQUESTED,
    payload: data,
  })
}
